import start from './login.jsx';

if (!window.MATERIO_UNSUPPORTED_BROWSER_DETECTED) {
  start();
}
